module.exports = __webpack_public_path__ + "c7b751d85561bc49def4146311ca59ca.png";


//////////////////
// WEBPACK FOOTER
// ./public/pic4@2x.png
// module id = 211
// module chunks = 1